import React, { useState } from 'react';
import '../Global.css';
import ServerSelector from './ServerSelector';
import { useNavigate } from "react-router-dom";

function Navbar() {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false); // Menü durumu

    // Menüyü açıp kapatma fonksiyonu
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            {/* Sadece Mobilde Görünecek Üst Bar ve Hamburger Butonu */}
            <div className="mobile-header">
                <a href="/" className="mobile-logo" style={{ textDecoration: 'none' }}>
                    tournaments <span style={{ color: '#029220' }}>|</span> admin
                </a>
                <button className="hamburger-btn" onClick={toggleMenu}>
                    {isOpen ? '✕' : '☰'}
                </button>
            </div>

            {/* Menü açıkken arka planı karartan tıklanabilir alan */}
            {isOpen && <div className="mobile-overlay" onClick={toggleMenu}></div>}

            {/* Sidebar (Mobilde class ile açılıp kapanacak) */}
            <div className={`sidebar ${isOpen ? 'open' : ''}`}>
                <a href="/" className="logo desktop-logo">
                    tournaments <span style={{ color: '#029220' }}>|</span> admin
                </a>

                <ServerSelector />

                <div className="nav-links-container">
                    <div className='create-tournament'>
                        <a href='/dashboard' className='create-tournament-link' onClick={toggleMenu}>Dashboard</a>
                    </div>
                    <div className='create-tournament'>
                        <a href='/all' className='create-tournament-link' onClick={toggleMenu}>Turnuvalar</a>
                    </div>
                    <div className='create-tournament'>
                        <a href='/create' className='create-tournament-link' onClick={toggleMenu}>Create Tournament</a>
                    </div>

                    <div className='create-tournament'>
                        <a href='/search' className='create-tournament-link' onClick={toggleMenu}>Search</a>
                    </div>

                    <div className='create-tournament'>
                        <a href='/play' className='create-tournament-link' onClick={toggleMenu}>Playlist Turnuvası</a>
                    </div>

                    <div className='create-tournament'>
                        <a href='/push-notification' className='create-tournament-link' onClick={toggleMenu}>Push Notification</a>
                    </div>

                    <div className='create-tournament'>
                        <a href='/pending-tournaments' className='creatwe-tournament-link' onClick={toggleMenu}>Bekleyen Turnuvalar</a>
                    </div>
                    <div className='create-tournament'>
                        <a href='/chat' className='create-tournament-link' onClick={toggleMenu}>Chat Test</a>
                    </div>
                    <div className='create-tournament'>
                        <a href='/health' className='create-tournament-link' onClick={toggleMenu}>Health</a>
                    </div>

                    <div style={{ marginTop: 'auto', padding: '15px', borderTop: '1px solid #252525' }}>
                        <a onClick={() => {
                            localStorage.clear();
                            navigate("/login");
                            toggleMenu(); // Çıkış yaparken de menüyü kapat
                        }} className='create-tournament-link' style={{ color: '#ff4d4d', cursor: 'pointer' }}>Çıkış</a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Navbar;